<script lang="ts">
  import {onMount} from 'svelte';
  import MediaService from '../../../../services/media';
  import {AssetService} from '../../../../services';
  import {writable} from 'svelte/store';
  import AudioElement from './AudioElement.svelte';
  import {toasts} from 'svelte-toasts';
  import Swal from 'sweetalert2';
  import {createFileUploadDialog, validateMusicFile} from '../../../../utils/common';
  import {httpClient} from '../../../../utils/http-client';
  import {logError} from '../../../../utils/logs';
  import {helpStore} from '@/store';
  import {ProcessState} from '@/types/common';
  import LoaderPlus from '@/components/loader/LoaderPlus.svelte';
  let masterPause = writable(false);

  const assets = writable<any>([]);
  const media = writable<any>([]);
  const mediaService = new MediaService();
  const assetService = new AssetService();
  let isUploading: boolean = false;

  function deleteMusic(music: any) {
    assets.update(store => {
      return store.filter((item: {id: string}) => item.id !== music.id);
    });
    assetService.deleteAsset(music.id).then(resp => {
      console.log('Media deleted', resp);
    });
  }

  onMount(() => {
    mediaService.fetchAll().then(data => {
      media.set(data);
    });

    assetService.fetchAll().then(data => {
      assets.set(data.filter(item => item.category.name == 'music'));
    });

    let parent = document.getElementById('step-3-music') || null;
    if (!parent) return;

    let dot = Object.assign(document.createElement('div'), {
      className: 'dot',
      onclick: () => helpStore.set({activeId: 'step-3-music'})
    });

    parent.classList.add('relative');
    parent.appendChild(dot);
  });

  let audio: HTMLElement;
  const fetchAssets = async () => {
    const data = await assetService.fetchAll();
    assets.set(data.filter(item => item.category.name == 'music'));
  };

  const upload = async <T extends any>(type: T): Promise<any[T] | null> => {
    try {
      const files = await createFileUploadDialog();
      const formData = new FormData();

      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        if (file) {
          if (validateMusicFile(file.name)) {
            formData.append('files', file);
          } else {
            Swal.fire({
              title: 'Invalid file type',
              text: `Please upload a valid file (mp3, flac, wav)`,
              icon: 'error'
            });
            return null;
          }
        }
      }
      formData.append('type', 'music');
      isUploading = true;
      const response = await httpClient.post('/assets', formData, {
        onUploadProgress: progressEvent => {
          const {loaded, total} = progressEvent;
          const progress = (loaded / total) * 100;
        }
      });
      const data = response.data;
      isUploading = false;
      return data;
    } catch (err) {
      isUploading = false;
      logError('Error in upload', err);
      Swal.fire({
        titleText: 'Problem with upload',
        text: 'There was a problem with your file. Our service could not successfully process it, if the issue continues to persist, please contact us',
        icon: 'error'
      });
    }
    return null;
  };

  const uploadMusic = async () => {
    const data = await upload('music');
    if (data) {
      fetchAssets();
      toasts.add({
        title: 'Success',
        description: 'Music file successfully uploaded',
        duration: 1500, // 0 or negative to avoid auto-remove
        placement: 'top-left',
        type: 'success',
        theme: 'light'
      });
    }
  };
</script>

<div class="p-2">
  <div class="mb-4 flex items-center gap-2">
    <h1 class="block pt-1 text-left text-xl font-bold">Personal music</h1>
    <button
      class="my-2 ml-auto block rounded-lg border-2 border-primary p-1 px-2 text-xs font-bold text-primary transition-colors duration-100 hover:bg-primary-600 hover:text-white"
      on:click={uploadMusic}><i class="fa fa-plus text-xs" /> Upload music</button
    >
  </div>
  {#if isUploading}
    <LoaderPlus status={ProcessState.BUSY} heading="Uploading Audio" />
  {/if}
  {#if $assets.length == 0}
    <span class="mb-4 block w-full py-4 text-center text-sm text-gray-500">No music uploaded yet</span>
  {:else}
    <div class="mb-4 flex flex-col gap-4">
      {#each $assets as asset}
        <AudioElement mediaItem={asset} deleteMusic={() => deleteMusic(asset)} />
      {/each}
    </div>
  {/if}

  <div class="mb-4 flex flex-col items-center gap-2">
    <h1 class="mb-4 block w-full text-left text-xl font-bold" id="step-3-music">Community music</h1>
  </div>
  <div class="flex flex-col gap-2">
    {#each $media as mediaItem}
      <AudioElement {mediaItem} bind:masterPause deleteMusic={() => {}} />
    {/each}
  </div>
</div>
